/* eslint-env browser */
import * as React from 'react'

const PropTypes = require('prop-types')
const axios = require('axios')

const Counterpart = require('@gandi/counterpart').Instance
const translate = new Counterpart()
translate.registerTranslations('en', require('./i18n/en'))
translate.registerTranslations('fr', require('./i18n/fr'))

const ValidatedInput = require('../../custom/gunki-iron-tournament-2018-pre-registration/components/ValidatedInput')

function joinTeamCouponCodeValid(coupon) {
  return !!coupon && coupon.length > 3
}

class JoinContestTeam extends React.Component {
  constructor() {
    super()
    this.state = {
      couponNotFound: false,
      getTeamError: false,
    }
    this.getTeamByCoupon = this.getTeamByCoupon.bind(this)
  }

  componentWillMount() {
    const { appConfig } = this.props
    if (appConfig.locale.identifierShort !== translate.getLocale()) {
      translate.setLocale(appConfig.locale.identifierShort)
    }
  }

  getTeamByCoupon() {
    this.setState({ loading: true })

    const { contestId, contestMaxNumberOfPeopleInTeam } = this.props
    const { joinTeamCouponCode } = this.state

    axios
      .get(`/api/contests/${contestId}/teams`, {
        params: { joinCode: joinTeamCouponCode },
      })
      .then(res => {
        this.setState({ loading: false })
        if (res && res.data) {
          if (res.data.members && res.data.members.length >= contestMaxNumberOfPeopleInTeam) {
            window.alert(translate.translate('joinTeam.teamFullAlert'))
            return
          }
        }
        this.setState({ couponNotFound: false, getTeamError: false }, () => {
          const team = res.data
          axios
            .post(`/api/contests/${contestId}/register`, {
              joinTeamId: team.id,
              joinTeamCouponCode,
            })
            .then(() => {
              window.alert(translate.translate('joinTeam.joinedAlert'))
              this.setState({ loading: false })
              window.location.reload(true)
            })
            .catch(() => {
              this.setState({ loading: false })
              window.alert(translate.translate('joinTeam.getTeamError'))
            })
        })
      })
      .catch(err => {
        if (err && err.response) {
          if (err.response.status === 404) {
            this.setState({ loading: false, couponNotFound: true })
            return
          }
        }
        this.setState({ loading: false, getTeamError: true })
      })
  }

  render() {
    const { loading, joinTeamCouponCode, couponNotFound, getTeamError } = this.state
    const { isLoggedIn, contestRegistration } = this.props
    if (!isLoggedIn) {
      return (
        <div>
          <i className="fas fa-exclamation-triangle has-text-warning">&nbsp;</i>
          {translate.translate('joinTeam.pleaseLogin')}
        </div>
      )
    }
    if (contestRegistration && contestRegistration.team) {
      const showCheckListButton =
        ((window.webkit || {}).messageHandlers || {}).observe ||
        (window.AndroidMessageObserver || {}).showContestPermissionCheckList
      return (
        <div className="column is-12">
          <span className="icon">
            <i className="fas fa-check is-primary">&nbsp;</i>
          </span>
          {translate.translate('joinTeam.alreadyJoined')}
          <table className="table has-margin-top-small">
            <tbody>
              <tr>
                <th>{translate.translate('joinTeam.team.teamName')}</th>
                <td>{contestRegistration.team.name}</td>
              </tr>
            </tbody>
          </table>
          <table className="table">
            <tbody>
              <tr>
                <th>{translate.translate('joinTeam.team.joinCode')}</th>
                <td>{contestRegistration.team.joinCode}</td>
              </tr>
            </tbody>
          </table>
          <div style={{ width: '100%', textAlign: 'center', paddingTop: 32 }}>
            {showCheckListButton && (
              <button
                type="button"
                className="button is-primary"
                onClick={() => {
                  if (((window.webkit || {}).messageHandlers || {}).observe) {
                    window.webkit.messageHandlers.observe.postMessage({ name: 'contest.showPermissionCheckList' })
                  }
                  if ((window.AndroidMessageObserver || {}).showContestPermissionCheckList) {
                    window.AndroidMessageObserver.showContestPermissionCheckList()
                  }
                }}
              >
                CHECKLIST &gt;
              </button>
            )}
          </div>
        </div>
      )
    }
    return (
      <div className="columns is-multiline is-centered has-text-centered">
        <div className="column is-12-mobile is-8-tablet is-4-desktop">
          <ValidatedInput
            initialValue=""
            placeholder="XXXXXX-YYYYYY"
            label=""
            inputId="join-team-coupon"
            autoCorrect="off"
            autoCapitalize="off"
            forceUppercase
            valid={value => joinTeamCouponCodeValid(value)}
            onChange={value => this.setState({ joinTeamCouponCode: (value || '').toUpperCase() })}
          />
        </div>
        <div className="column is-12 has-text-centered">
          <button
            type="submit"
            className={`button is-call-to-action ${loading ? 'is-loading' : ''}`}
            disabled={loading || !joinTeamCouponCodeValid(joinTeamCouponCode)}
            onClick={this.getTeamByCoupon}
          >
            {translate.translate('joinTeam.joinButton')}
          </button>
          {(couponNotFound || getTeamError) && (
            <React.Fragment>
              <br />
              <p className="has-text-danger has-padding-small">
                {couponNotFound && translate.translate('joinTeam.teamNotFound')}
                {getTeamError && translate.translate('joinTeam.getTeamError')}
              </p>
            </React.Fragment>
          )}
        </div>
      </div>
    )
  }
}

JoinContestTeam.propTypes = {
  appConfig: PropTypes.object.isRequired,
  contestId: PropTypes.string.isRequired,
  contestMaxNumberOfPeopleInTeam: PropTypes.number.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  contestRegistration: PropTypes.object,
}

JoinContestTeam.defaultProps = {
  contestRegistration: undefined,
}

module.exports = JoinContestTeam
